export default __webpack_public_path__ + "static/media/Layer 2_blue.7b61083e.svg";